document.addEventListener('DOMContentLoaded', function () {
    toggleMobileHamburgerMenu();
});

function toggleMobileHamburgerMenu() {
    const burgerMenuOpen = document.getElementById('burger-menu-open');
    const burgerMenuClose = document.getElementById('burger-menu-close');
    const mobileNav = document.getElementById('mobile-nav');

    const toggleElements = () => {
        mobileNav.classList.toggle('active');
    };

    burgerMenuOpen.addEventListener('click', toggleElements);
    burgerMenuClose.addEventListener('click', toggleElements);

    // Reset on click outside the menu
    window.addEventListener('click', function (e) {
        if (mobileNav.classList.contains('active') &&
            !mobileNav.contains(e.target) &&
            !burgerMenuOpen.contains(e.target)) {
            toggleElements();
        }
    });

    // Reset on orientation change
    window.addEventListener('orientationchange', function () {
        if (mobileNav.classList.contains('active')) {
            toggleElements();
        }
    });

    // Reset on resize at 900px
    window.addEventListener('resize', function () {
        if (mobileNav.classList.contains('active') && window.innerWidth > 900) {
            toggleElements();
        }
    });
}
